import { Injectable } from '@angular/core';
import { Collection, CollectionConfig } from '@cardium/core-client/collection';
import { IOption } from '@cardium/contracts';

@Injectable()
export class OptionCollection extends Collection<IOption> {
  protected config: CollectionConfig = {
    apiUrl: 'api/core/option',
  };
}
